import styled, { css } from 'styled-components';
/**
 * These styles are meant to match the shimmer state of the index page, currently defined in crm-index-ui-shimmer/static/js/components/Shimmer.tsx
 * We avoid a hard dep and instead copy-paste for now. Worst case scenario, the work is copy-pasting 28 lines. We would rather deal with that, than
 * library and dependency pain
 */
const LoadingCell = styled.div.attrs({
  'data-test-id': 'loading-cell',
  'aria-hidden': 'true'
})(({
  theme,
  width,
  height
}) => {
  return css(["display:block;border-radius:", ";width:", ";height:", ";background:linear-gradient( to right,", ",", " 20%,", " 40% );background-size:200% 100%;animation:shimmer 1.5s infinite linear;@keyframes shimmer{0%{background-position:100% 0;}100%{background-position:-100% 0;}}"], theme.borderRadius[300], width && theme.space[width] || '100%', height && theme.space[height] || '60%', theme.color['fill-tertiary-hover'], theme.color['fill-tertiary-default'], theme.color['fill-tertiary-hover']);
});
export default LoadingCell;